import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { StrapiWorkOrderUpdateData } from '../../api/strapiCrm';
import { strapiUpdateWorkOrder } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useUpdateWorkOrderMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ documentId, data }: { documentId: string; data: StrapiWorkOrderUpdateData }) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiUpdateWorkOrder(jwt, documentId, data);
    },
    onSuccess: async (_, { documentId }) => {
      await qc.invalidateQueries({ queryKey: queryKeys.workOrdersListPrefix(jwt) });
      await qc.invalidateQueries({ queryKey: queryKeys.workOrderDetail(jwt, documentId) });
    },
  });
}
